<template>
  <proa-modal
    :modal="modalWithObject != null"
    @close="$emit('close')"
    fluid
    hideFooter
    noDefaultBodyPadding
  >
    <template v-slot:headerTitle>
      <div class="text-secondary font-weight-w6 header-title">{{ modalWithObject.fileName }}</div>
    </template>
    <template v-slot:headerAsset v-if="downloadable">
      <span @click="onClickDownload" class="download-button">
        <img :src="require('@/assets/images/icons/download.png')"/>
      </span>
    </template>
    <div class="pdf-modal-content">
      <div v-if="downloadError" class="text-center">
        <span class="d-block text-secondary font-weight-w6 mb-2">ダウンロードエラー</span>
        <span class="d-block text-secondary mb-3">ファイルの取得に失敗しました</span>
      </div>
      <div v-else-if="!downloadable" class="loading-wrapper">
        <proa-loading class="loading"/>
      </div>
      <div v-else class="preview-wrapper">
        <iframe ref="previewPdf" width="100%" height="100%"/>
      </div>
    </div>
  </proa-modal>
</template>

<script>
import DownloadPrivateFile from '@/lib/DownloadPrivateFile'

export default {
  name: 'PDFModal',
  props: {
    modalWithObject: Object
  },
  data() {
    return {
      downloadError: false,
      downloadPrivateFile: null,
      previewableType: false,
      downloadable: false,
      size: 0
    }
  },
  methods: {
    onClickDownload: function() {
      if (!this.downloadable) return
      this.downloadPrivateFile.download()
    }
  },
  watch: {
    modalWithObject: function(value) {
      if (value) {
        this.downloadPrivateFile = new DownloadPrivateFile({
          url: value.url,
          fileName: value.fileName
        })
        this.downloadPrivateFile.on('download', (pyaload) => {
          const { data, previewableType } = pyaload

          this.size = data.size
          this.previewableType = previewableType
          this.downloadable = true

          setTimeout(() => {
            this.$refs.previewPdf.src = URL.createObjectURL(data) + '#toolbar=0&navpanes=0'
          }, 0)
        })
        this.downloadPrivateFile.on('error', () => {
          this.downloadError = true
        })
      } else {
        this.downloadError = false
        this.downloadPrivateFile = null
        this.previewableType = false
        this.downloadable = false
        this.size = 0
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
.download-button {
  margin-right: 10px;
  display: inline-block;
  width: 26px;
  height: 26px;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    padding: 3px;
  }
}

.header-title {
  flex-grow: 1;
  width: 1px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.pdf-modal-content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .preview-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
  }
}

.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 40px;

  .loading {
    width: 80px;
    height: 80px;
  }
}
</style>
